import { type QuickEntryItem, type QuickEntryItemPC } from "./models";
import { getFirstValidDate } from "../utils/dateUtils";

import { getInitialPriceReference } from "~/AddToCart/redux/addToCart/getInitialPriceReference";

export function getEmptyRow(): QuickEntryItem {
  return {
    quantity: 1,
    product: undefined,
    productId: "",
    previousProductId: "",
    packCode: "",
    requestedDeliveryDate: getFirstValidDate(),
    isCommentVisible: false,
    comment: "",
    priceReference: getInitialPriceReference(),
  };
}
export const EMPTY_ROW_PC: QuickEntryItemPC = {
  product: undefined,
  productId: "",
  previousProductId: "",
};

export const INVALID_ENTRY_ID = -1;
